import { AcceptInvitation } from '~/pages/auth/AcceptInvitation'
import { EmailCode } from '~/pages/auth/EmailCode'
import { ForgotPassword } from '~/pages/auth/ForgotPassword'
import { Login } from '~/pages/auth/Login'
import { OAuthCallback } from '~/pages/auth/OAuthCallback'
import { ResetPassword } from '~/pages/auth/ResetPassword'
import { chatsRoute } from '~/pages/chats/ChatsRoutes'
import { homeRoute } from '~/pages/home/HomeRoutes'
import { TestPage } from '~/pages/home/TestPage'
import { SettingsPage, handle as settingsHandle } from '~/pages/settings/SettingsPage'
import { lazy } from '~/router/lazy'
import { RequireAuth } from '~/router/RequireAuth'
import { RootLayout } from '~/router/RootLayout'
import type { AppRouteObject } from '~/router/types'
import { Shell } from '~/shell/Shell'

export const routes: AppRouteObject[] = [
  {
    path: '/',
    Component: RootLayout,
    HydrateFallback: () => null,
    children: [
      // ── Auth routes (public, no shell) ──
      { path: 'auth/login', Component: Login },
      { path: 'auth/forgot-password', Component: ForgotPassword },
      { path: 'auth/email-code', Component: EmailCode },
      { path: 'auth/reset-password', Component: ResetPassword },
      { path: 'auth/accept-invitation', Component: AcceptInvitation },
      { path: 'oauth/callback', Component: OAuthCallback },

      // ── Shell routes (authenticated) ──
      {
        Component: RequireAuth,
        children: [
          {
            Component: Shell,
            children: [
              // Index route mirrors Home without redirecting URL
              { index: true, handle: { title: 'Home' }, Component: TestPage },

              // Domain routes
              homeRoute,

              // Inbox section
              {
                path: 'inbox',
                handle: { title: 'Inbox' },
                lazy: lazy(() => import('~/pages/inbox/Inbox')),
              },

              chatsRoute,

              { path: 'settings', handle: settingsHandle, Component: SettingsPage },
            ],
          },
        ],
      },
    ],
  },
]
